/* eslint @typescript-eslint/no-unsafe-argument: "off" */
import {
  type Href,
  useFocusEffect,
  useLocalSearchParams,
  useRouter,
} from "expo-router"
import { setAuthToken, setRedirectState } from "@/stores/auth"
import { forceAnonId } from "@/analytics/react"

type RedirectSearchParams = {
  state?: string
  token?: string
  anonId?: string
  next?: string
} & Record<string, string | string[]>

export default function RedirectScreen() {
  const { state, token, next, anonId } =
    useLocalSearchParams<RedirectSearchParams>()
  const router = useRouter()

  useFocusEffect(() => {
    if (anonId) {
      void forceAnonId(anonId)
    }

    if (token) {
      setAuthToken(token)
    }

    if (state) {
      setRedirectState(state)
    }

    if (!!next && next.startsWith("/")) {
      // NOTE (amcclosky): Only accept relative paths as valid next values,
      // otherwise the param could be abused to redirect outside our domain.
      router.replace(next as Href)
    } else {
      router.replace("/")
    }
  })

  return <></>
}
